import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AppConfigDTO {
  googleClientId: string;
  linkedinClientId: string;
  linkedinClientSecret: string;
  linkedinRedirectUri: string;
  stripeMode: string;
  stripeApiKey: string;
  stripeTestApiKey: string;
  stripePublicKey: string;
  stripeTestPublicKey: string;
  stripeWebhookSecret: string;
  stripeTestWebhookSecret: string;
  stripePriceIdMonthly: string;
  stripeTestPriceIdMonthly: string;
  stripePriceIdAnnual: string;
  whatzmeToken: string;
  whatzmeBaseUrl: string;
  whatsappAdminNumbers: string;
  deepseekApiKey: string;
  promptNormalizador: string;
  promptCvOptimizer: string;
  promptGuruMatchExtraccion: string;
  promptGuruMatchScoring: string;
  smtpHost: string;
  smtpPort: string;
  smtpUsername: string;
  smtpPassword: string;
  smtpFrom: string;
  smtpFromName: string;
  smtpSet: boolean;
  googleSet: boolean;
  linkedinSet: boolean;
  stripeSet: boolean;
  whatzmeSet: boolean;
  deepseekSet: boolean;
  mesesVacantes: number;
  horasVacantesRecientes: number;
  guruMatchMinScore: number;
  guruMatchMaxResults: number;
  freebieMatchCount: number;
  freebieJobHours: number;
  freeAlertLimit: number;
  freeGuruMatchLimit: number;
  freeCvOptimizerLimit: number;
  freeCvLimit: number;
  premiumCvLimit: number;
  freeGuruMatchVisible: number;
  freeAlertVisible: number;
  premiumAlertLimitDay: number;
  premiumGuruMatchLimitDay: number;
  premiumCvOptimizerLimitDay: number;
  freeAlertEmail: boolean;
  freeAlertWhatsapp: boolean;
  premiumAlertEmail: boolean;
  premiumAlertWhatsapp: boolean;
  jwtExpirationHours: number;
  scraperHabilitado: boolean;
  alertasHabilitadas: boolean;
  openaiApiKey: string;
  openaiSet: boolean;
  wordpressBaseUrl: string;
  wordpressApiBaseUrl: string;
  wordpressUsername: string;
  wordpressAppPassword: string;
  wordpressSet: boolean;
  wordpressEnabled: boolean;
  wordpressReady: boolean;
  facebookPageId: string;
  facebookPageAccessToken: string;
  facebookSet: boolean;
  facebookEnabled: boolean;
  facebookReady: boolean;
  instagramBusinessAccountId: string;
  instagramSet: boolean;
  instagramEnabled: boolean;
  instagramReady: boolean;
  linkedinOrganizationId: string;
  linkedinOrgAccessToken: string;
  linkedinOrgSet: boolean;
  linkedinEnabled: boolean;
  linkedinReady: boolean;
  promptSocialCopy: string;
  autoPublishSocialEnabled: boolean;
  // Bot WhatsApp entrante
  whatsappBotEnabled: boolean;
  whatsappWebhookSecret: string;
  promptWhatsappIntent: string;
  promptWhatsappReply: string;
  whatsappTriggerKeyword: string;
  whatsappSessionTimeoutMinutes: number;
  // Google Indexing API
  googleIndexingEnabled: boolean;
  googleIndexingServiceAccountJson: string;
  googleIndexingSet: boolean;
}

@Injectable({ providedIn: 'root' })
export class AdminConfigService {

  private base = `${environment.baseApi}/admin/app/config`;

  constructor(private http: HttpClient) {}

  get(): Observable<any> {
    return this.http.get(this.base);
  }

  getTokens(): Observable<any> {
    return this.http.get(`${this.base}/tokens`);
  }

  save(payload: Partial<AppConfigDTO>): Observable<any> {
    return this.http.post(this.base, payload);
  }

  testSmtp(to: string): Observable<any> {
    return this.http.post(`${this.base}/smtp/test`, { to });
  }

  testOpenai(): Observable<any> {
    return this.http.post(`${this.base}/openai/test`, {});
  }

  testDeepseek(): Observable<any> {
    return this.http.post(`${this.base}/deepseek/test`, {});
  }

  testWordpress(): Observable<any> {
    return this.http.post(`${this.base}/wordpress/test`, {});
  }

  testFacebook(): Observable<any> {
    return this.http.post(`${this.base}/facebook/test`, {});
  }

  testInstagram(): Observable<any> {
    return this.http.post(`${this.base}/instagram/test`, {});
  }

  testLinkedin(): Observable<any> {
    return this.http.post(`${this.base}/linkedin/test`, {});
  }

  resetWhatsappPrompts(): Observable<any> {
    return this.http.post(`${environment.baseApi}/admin/app/config/reset-whatsapp-prompts`, {});
  }

  testGoogleIndexing(): Observable<any> {
    return this.http.post(`${this.base}/google-indexing/test`, {});
  }

  indexAllVacancies(): Observable<any> {
    return this.http.post(`${this.base}/google-indexing/index-all`, {});
  }
}
